'use strict';

import React from 'react';
import PropTypes from 'prop-types';
const find = require('lodash/find');
import { Row, Card, Button } from 'react-bootstrap';
const uuid = require('uuid');
const Moment = require('moment');

const Globals = require('../../../../app/globals');
const StringUtil = require('../../../../app/shared/StringUtil');
const AdminGlobalUserStore = require('../../stores/AdminGlobalUserStore');
const SubscriptionPlanStore = require('../../stores/SubscriptionPlanStore');
const SubscriptionPlanActions = require('../../actions/SubscriptionPlanActions');
import ConfirmModal from '../modal/ConfirmModal';
import LoadingMainContent from '../loading/LoadingMainContent';
import SortableTableClassic from '../table/SortableTableClassic';
import NewSubscriptionPlanModal from '../modal/NewSubscriptionPlanModal';
import WarningBox from '../common/WarningBox';

const propTypes = {};
const defaultProps = {};

var plan_columns = [
    {
        displayName: 'ID',
        key:'id',
        size: 1,
        type: 'int'
    },
    {
        displayName: 'Token',
        key:'token',
        size: 3,
        type: 'string'
    },
    {
        displayName: 'Display Name',
        key:'display_name',
        size: 3,
        type: 'string'
    },
    {
        displayName: 'Created Date',
        key:'created_at',
        size: 3,
        type: 'date'
    },
    {
        displayName: 'Acc. Type',
        key: 'account_type',
        size: 2,
        type: 'string'
    },
    {
        displayName: 'Pay',
        key: 'process_type',
        size: 2,
        type: 'string'
    },
    {
        displayName: 'Interval',
        key: 'interval',
        size: 2,
        type: 'string'
    },
    {
        displayName: 'Cost',
        key: 'formatted_cost',
        size: 2,
        type: 'string'
    },
    {
        displayName: 'Subscribers',
        key: 'user_count',
        size: 2,
        type: 'int'
    },
]; // plan_columns

var subscriber_columns = [
    {
        displayName: 'ID',
        key:'id',
        size: 1,
        type: 'int',
        width: '5%'
    },
    {
        displayName: 'First Name',
        key:'first_name',
        size: 2,
        type: 'string',
        width: '10%'
    },
    {
        displayName: 'Last Name',
        key:'last_name',
        size: 2,
        type: 'string',
        width: '10%'
    },
    {
        displayName: 'Created Date',
        key:'created_at',
        size: 3,
        type: 'date',
        width: '12.5%'
    },
    {
        displayName: 'Last Active',
        key:'active_at',
        size: 3,
        type: 'date',
        width: '12.5%'
    },
    {
        displayName: 'Email',
        key: 'email',
        size: 3,
        type: 'string',
        width: '25%'
    },
    {
        displayName: 'Acc. Type',
        key: 'account_type',
        size: 2,
        type: 'string',
        width: '10%'
    },
    {
        displayName: 'Subscription Create',
        key: 'subscription_created_at',
        size: 2,
        type: 'date',
        width: '10%'
    },
    {
        displayName: 'Subscription End',
        key: 'subscription_ending_at',
        size: 2,
        type: 'date',
        width: '10%'
    },
    {
        displayName: 'Subscription Status',
        key: 'subscription_status',
        size: 2,
        type: 'string',
        width: '5%'
    },
];

class AdminSubscriptionPlansView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userStoreState: AdminGlobalUserStore.getState(),
            subscriptionPlanStoreState: SubscriptionPlanStore.getState(),
            selectedPlan: null,
            showSelectedPlanUsers: false,
            showNewPlanModal: false,
            showArchivePlanModal: false,
            archivePlanError: null,
            archivePlanActionId: null,
        };

        this.onChangeModalState = this.onChangeModalState.bind(this);
        this.onPlanClick = this.onPlanClick.bind(this);
        this.handleArchivePlan = this.handleArchivePlan.bind(this);
        this.anyModalsOpen = this.anyModalsOpen.bind(this);
        this.toggleShowSelectedPlanUsers = this.toggleShowSelectedPlanUsers.bind(this);
        this.unsubscribes = [
            SubscriptionPlanStore.listen(this.onSubscriptionPlanStoreChange.bind(this)),
            AdminGlobalUserStore.listen(this.onAdminGlobalUserStoreChange.bind(this)),
        ];
    }

    UNSAFE_componentWillMount() {
        SubscriptionPlanActions.getPlans(uuid.v4());
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onSubscriptionPlanStoreChange(state) {
        let additionalState = {};
        if (state.action.id === this.state.archivePlanActionId) {
            additionalState = {
                archivePlanActionId: null,
                archivePlanError: state.action.error || null,
                showArchivePlanModal: !!state.action.error,
            };
        }

        this.setState({ subscriptionPlanStoreState: state, ...additionalState });
    }

    onAdminGlobalUserStoreChange(state) {
        this.setState({ userStoreState: state });
    }

    onChangeModalState(stateProp, showBool) {
        this.setState({ [stateProp]: showBool })
    }

    onPlanClick(e, planId) {
        const plan = find(this.state.subscriptionPlanStoreState.plans, { id: planId });
        this.setState({
            selectedPlan: plan,
            showSelectedPlanUsers: false,
        });
    }

    handleArchivePlan() {
        const archivePlanActionId = uuid.v4();
        this.setState({ archivePlanActionId: archivePlanActionId }, () => {
            SubscriptionPlanActions.archivePlan(archivePlanActionId, this.state.selectedPlan.id);
        })
    }

    anyModalsOpen() {
        return this.state.showNewPlanModal || this.state.showArchivePlanModal;
    }

    toggleShowSelectedPlanUsers() {
        this.setState({ showSelectedPlanUsers: !this.state.showSelectedPlanUsers });
    }

    render() {
        const self = this;
        if (this.state.subscriptionPlanStoreState.loading) {
            return <LoadingMainContent />;
        }

        const plan_rows = this.state.subscriptionPlanStoreState.plans.map((plan) => {
            return {
                user_count: plan.users.length,
                formatted_cost: StringUtil.formatUSD(plan.cost),
                ...plan,
            }
        });

        let selectedPlanContent;
        if (this.state.selectedPlan) {
            const plan = this.state.selectedPlan;
            const canArchive = (!plan.users || (plan.users.length === 0)) && !this.anyModalsOpen();
            let subscriberList = null;
            const now = Moment(new Date());
            if (this.state.showSelectedPlanUsers) {
                subscriberList = <WarningBox>Disabled: Requires rewrite to account for paginated user endpoint.</WarningBox>;

                /*
                const subscriber_rows = plan.users.map((entry) => {
                    const user = find(this.state.userStoreState.authors, { id: entry.user_id });
                    const sd = user.subscription_data;
                    let account_status = sd.subscription_status;
                    if (sd.subscription_status === Globals.ecommerce.subscription_statuses.active) {
                        if (sd.subscription_ending_at) {
                            const end_date = Moment(sd.subscription_ending_at);
                            if (end_date.isBefore(now)) {
                                account_status = 'end ' + end_date.format('YYYY-MM-DD');
                            }
                        }
                    }

                    return {
                        id:                         user.id,
                        first_name:                 user.first_name,
                        last_name:                  user.last_name,
                        created_at:                 user.created_at,
                        active_at:                  user.active_at,
                        email:                      user.email,
                        account_type:               user.account_type,
                        subscription_created_at:    sd.subscription_created_at,
                        subscription_status:        account_status,
                        subscription_ending_at:     sd.subscription_ending_at,
                    };
                });

                subscriberList = (
                    <SortableTableClassic
                        key="t-subscribers"
                        title="Subscribers"
                        rows={subscriber_rows}
                        dateFormat="YYYY-MM-DD"
                        columns={subscriber_columns}
                    />
                );
                */
            }

            selectedPlanContent = (
                <Row>
                    <div className="selected-plan-action-buttons">
                        <button
                            className="btn btn-danger"
                            disabled={!canArchive}
                            onClick={this.onChangeModalState.bind(this, "showArchivePlanModal", true)}
                        >
                            Archive
                        </button>
                        <button
                            className="btn btn-primary"
                            disabled={plan.user_count < 1}
                            onClick={this.toggleShowSelectedPlanUsers}
                        >
                            Subscribers
                        </button>
                    </div>
                    {subscriberList}
                </Row>
            );
        }

        return (
            <div>
                {this.state.showNewPlanModal &&
                    <NewSubscriptionPlanModal
                        show
                        closeHandler={this.onChangeModalState.bind(this, "showNewPlanModal", false)}
                    />
                }
                {this.state.showArchivePlanModal &&
                    <ConfirmModal
                        show
                        modalTitle="Archive Plan"
                        text="Are you sure you want to archive this plan?"
                        buttonText="archive"
                        closeHandler={this.onChangeModalState.bind(this, "showArchivePlanModal", false)}
                        confirmHandler={this.handleArchivePlan}
                        hasError={!!this.state.archivePlanError}
                        message={this.state.archivePlanError}
                    />
                }
                <div className="margin-bottom-lg">
                    <Card body bg="light">
                        <Button
                            onClick={this.onChangeModalState.bind(this, "showNewPlanModal", true)}
                            disabled={this.anyModalsOpen()}
                        >
                            Add New Subscription Plan
                        </Button>
                    </Card>
                </div>
                <Card body bg="light">
                    <SortableTableClassic
                        key="t-plan"
                        title="Subscription Plans"
                        onRowClick={this.onPlanClick}
                        rows={plan_rows}
                        selectedRowKey={!!this.state.selectedPlan ? this.state.selectedPlan.id : null}
                        dateFormat="YYYY-MM-DD HH:mm:ss"
                        columns={plan_columns}
                    />
                </Card>
                {selectedPlanContent}
            </div>
        );
    }
}

AdminSubscriptionPlansView.propTypes = propTypes;
AdminSubscriptionPlansView.defaultProps = defaultProps;

export default AdminSubscriptionPlansView;